/*! sticky-sidebar - v3.3.1 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e(t.StickySidebar={})}(this,function(t){"use strict";"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var e,i,n=(function(t,e){(function(t){Object.defineProperty(t,"__esModule",{value:!0});var l,n,e=function(){function n(t,e){for(var i=0;i<e.length;i++){var n=e[i];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n)}}return function(t,e,i){return e&&n(t.prototype,e),i&&n(t,i),t}}(),i=(l=".stickySidebar",n={topSpacing:0,bottomSpacing:0,containerSelector:!1,innerWrapperSelector:".inner-wrapper-sticky",stickyClass:"is-affixed",resizeSensor:!0,minWidth:!1},function(){function c(t){var e=this,i=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),this.options=c.extend(n,i),this.sidebar="string"==typeof t?document.querySelector(t):t,void 0===this.sidebar)throw new Error("There is no specific sidebar element.");this.sidebarInner=!1,this.container=this.sidebar.parentElement,this.affixedType="STATIC",this.direction="down",this.support={transform:!1,transform3d:!1},this._initialized=!1,this._reStyle=!1,this._breakpoint=!1,this.dimensions={translateY:0,maxTranslateY:0,topSpacing:0,lastTopSpacing:0,bottomSpacing:0,lastBottomSpacing:0,sidebarHeight:0,sidebarWidth:0,containerTop:0,containerHeight:0,viewportHeight:0,viewportTop:0,lastViewportTop:0},["handleEvent"].forEach(function(t){e[t]=e[t].bind(e)}),this.initialize()}return e(c,[{key:"initialize",value:function(){var i=this;if(this._setSupportFeatures(),this.options.innerWrapperSelector&&(this.sidebarInner=this.sidebar.querySelector(this.options.innerWrapperSelector),null===this.sidebarInner&&(this.sidebarInner=!1)),!this.sidebarInner){var t=document.createElement("div");for(t.setAttribute("class","inner-wrapper-sticky"),this.sidebar.appendChild(t);this.sidebar.firstChild!=t;)t.appendChild(this.sidebar.firstChild);this.sidebarInner=this.sidebar.querySelector(".inner-wrapper-sticky")}if(this.options.containerSelector){var e=document.querySelectorAll(this.options.containerSelector);if((e=Array.prototype.slice.call(e)).forEach(function(t,e){t.contains(i.sidebar)&&(i.container=t)}),!e.length)throw new Error("The container does not contains on the sidebar.")}"function"!=typeof this.options.topSpacing&&(this.options.topSpacing=parseInt(this.options.topSpacing)||0),"function"!=typeof this.options.bottomSpacing&&(this.options.bottomSpacing=parseInt(this.options.bottomSpacing)||0),this._widthBreakpoint(),this.calcDimensions(),this.stickyPosition(),this.bindEvents(),this._initialized=!0}},{key:"bindEvents",value:function(){window.addEventListener("resize",this,{passive:!0,capture:!1}),window.addEventListener("scroll",this,{passive:!0,capture:!1}),this.sidebar.addEventListener("update"+l,this),this.options.resizeSensor&&"undefined"!=typeof ResizeSensor&&(new ResizeSensor(this.sidebarInner,this.handleEvent),new ResizeSensor(this.container,this.handleEvent))}},{key:"handleEvent",value:function(t){this.updateSticky(t)}},{key:"calcDimensions",value:function(){if(!this._breakpoint){var t=this.dimensions;t.containerTop=c.offsetRelative(this.container).top,t.containerHeight=this.container.clientHeight,t.containerBottom=t.containerTop+t.containerHeight,t.sidebarHeight=this.sidebarInner.offsetHeight,t.sidebarWidth=this.sidebarInner.offsetWidth,t.viewportHeight=window.innerHeight,t.maxTranslateY=t.containerHeight-t.sidebarHeight,this._calcDimensionsWithScroll()}}},{key:"_calcDimensionsWithScroll",value:function(){var t=this.dimensions;t.sidebarLeft=c.offsetRelative(this.sidebar).left,t.viewportTop=document.documentElement.scrollTop||document.body.scrollTop,t.viewportBottom=t.viewportTop+t.viewportHeight,t.viewportLeft=document.documentElement.scrollLeft||document.body.scrollLeft,t.topSpacing=this.options.topSpacing,t.bottomSpacing=this.options.bottomSpacing,"function"==typeof t.topSpacing&&(t.topSpacing=parseInt(t.topSpacing(this.sidebar))||0),"function"==typeof t.bottomSpacing&&(t.bottomSpacing=parseInt(t.bottomSpacing(this.sidebar))||0),"VIEWPORT-TOP"===this.affixedType?t.topSpacing<t.lastTopSpacing&&(t.translateY+=t.lastTopSpacing-t.topSpacing,this._reStyle=!0):"VIEWPORT-BOTTOM"===this.affixedType&&t.bottomSpacing<t.lastBottomSpacing&&(t.translateY+=t.lastBottomSpacing-t.bottomSpacing,this._reStyle=!0),t.lastTopSpacing=t.topSpacing,t.lastBottomSpacing=t.bottomSpacing}},{key:"isSidebarFitsViewport",value:function(){var t=this.dimensions,e="down"===this.scrollDirection?t.lastBottomSpacing:t.lastTopSpacing;return this.dimensions.sidebarHeight+e<this.dimensions.viewportHeight}},{key:"observeScrollDir",value:function(){var t=this.dimensions;if(t.lastViewportTop!==t.viewportTop){var e="down"===this.direction?Math.min:Math.max;t.viewportTop===e(t.viewportTop,t.lastViewportTop)&&(this.direction="down"===this.direction?"up":"down")}}},{key:"getAffixType",value:function(){this._calcDimensionsWithScroll();var t=this.dimensions,e=t.viewportTop+t.topSpacing,i=this.affixedType;return e<=t.containerTop||t.containerHeight<=t.sidebarHeight?(t.translateY=0,i="STATIC"):i="up"===this.direction?this._getAffixTypeScrollingUp():this._getAffixTypeScrollingDown(),t.translateY=Math.max(0,t.translateY),t.translateY=Math.min(t.containerHeight,t.translateY),t.translateY=Math.round(t.translateY),t.lastViewportTop=t.viewportTop,i}},{key:"_getAffixTypeScrollingDown",value:function(){var t=this.dimensions,e=t.sidebarHeight+t.containerTop,i=t.viewportTop+t.topSpacing,n=t.viewportBottom-t.bottomSpacing,o=this.affixedType;return this.isSidebarFitsViewport()?t.sidebarHeight+i>=t.containerBottom?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):i>=t.containerTop&&(t.translateY=i-t.containerTop,o="VIEWPORT-TOP"):t.containerBottom<=n?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):e+t.translateY<=n?(t.translateY=n-e,o="VIEWPORT-BOTTOM"):t.containerTop+t.translateY<=i&&0!==t.translateY&&t.maxTranslateY!==t.translateY&&(o="VIEWPORT-UNBOTTOM"),o}},{key:"_getAffixTypeScrollingUp",value:function(){var t=this.dimensions,e=t.sidebarHeight+t.containerTop,i=t.viewportTop+t.topSpacing,n=t.viewportBottom-t.bottomSpacing,o=this.affixedType;return i<=t.translateY+t.containerTop?(t.translateY=i-t.containerTop,o="VIEWPORT-TOP"):t.containerBottom<=n?(t.translateY=t.containerBottom-e,o="CONTAINER-BOTTOM"):this.isSidebarFitsViewport()||t.containerTop<=i&&0!==t.translateY&&t.maxTranslateY!==t.translateY&&(o="VIEWPORT-UNBOTTOM"),o}},{key:"_getStyle",value:function(t){if(void 0!==t){var e={inner:{},outer:{}},i=this.dimensions;switch(t){case"VIEWPORT-TOP":e.inner={position:"fixed",top:i.topSpacing,left:i.sidebarLeft-i.viewportLeft,width:i.sidebarWidth};break;case"VIEWPORT-BOTTOM":e.inner={position:"fixed",top:"auto",left:i.sidebarLeft,bottom:i.bottomSpacing,width:i.sidebarWidth};break;case"CONTAINER-BOTTOM":case"VIEWPORT-UNBOTTOM":var n=this._getTranslate(0,i.translateY+"px");e.inner=n?{transform:n}:{position:"absolute",top:i.translateY,width:i.sidebarWidth}}switch(t){case"VIEWPORT-TOP":case"VIEWPORT-BOTTOM":case"VIEWPORT-UNBOTTOM":case"CONTAINER-BOTTOM":e.outer={height:i.sidebarHeight,position:"relative"}}return e.outer=c.extend({height:"",position:""},e.outer),e.inner=c.extend({position:"relative",top:"",left:"",bottom:"",width:"",transform:""},e.inner),e}}},{key:"stickyPosition",value:function(t){if(!this._breakpoint){t=this._reStyle||t||!1,this.options.topSpacing,this.options.bottomSpacing;var e=this.getAffixType(),i=this._getStyle(e);if((this.affixedType!=e||t)&&e){var n="affix."+e.toLowerCase().replace("viewport-","")+l;for(var o in c.eventTrigger(this.sidebar,n),"STATIC"===e?c.removeClass(this.sidebar,this.options.stickyClass):c.addClass(this.sidebar,this.options.stickyClass),i.outer){var s="number"==typeof i.outer[o]?"px":"";this.sidebar.style[o]=i.outer[o]+s}for(var r in i.inner){var a="number"==typeof i.inner[r]?"px":"";this.sidebarInner.style[r]=i.inner[r]+a}var p="affixed."+e.toLowerCase().replace("viewport-","")+l;c.eventTrigger(this.sidebar,p)}else this._initialized&&(this.sidebarInner.style.left=i.inner.left);this.affixedType=e}}},{key:"_widthBreakpoint",value:function(){window.innerWidth<=this.options.minWidth?(this._breakpoint=!0,this.affixedType="STATIC",this.sidebar.removeAttribute("style"),c.removeClass(this.sidebar,this.options.stickyClass),this.sidebarInner.removeAttribute("style")):this._breakpoint=!1}},{key:"updateSticky",value:function(){var t,e=this,i=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this._running||(this._running=!0,t=i.type,requestAnimationFrame(function(){switch(t){case"scroll":e._calcDimensionsWithScroll(),e.observeScrollDir(),e.stickyPosition();break;case"resize":default:e._widthBreakpoint(),e.calcDimensions(),e.stickyPosition(!0)}e._running=!1}))}},{key:"_setSupportFeatures",value:function(){var t=this.support;t.transform=c.supportTransform(),t.transform3d=c.supportTransform(!0)}},{key:"_getTranslate",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:0,e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0,i=2<arguments.length&&void 0!==arguments[2]?arguments[2]:0;return this.support.transform3d?"translate3d("+t+", "+e+", "+i+")":!!this.support.translate&&"translate("+t+", "+e+")"}},{key:"destroy",value:function(){window.removeEventListener("resize",this,{capture:!1}),window.removeEventListener("scroll",this,{capture:!1}),this.sidebar.classList.remove(this.options.stickyClass),this.sidebar.style.minHeight="",this.sidebar.removeEventListener("update"+l,this);var t={inner:{},outer:{}};for(var e in t.inner={position:"",top:"",left:"",bottom:"",width:"",transform:""},t.outer={height:"",position:""},t.outer)this.sidebar.style[e]=t.outer[e];for(var i in t.inner)this.sidebarInner.style[i]=t.inner[i];this.options.resizeSensor&&"undefined"!=typeof ResizeSensor&&(ResizeSensor.detach(this.sidebarInner,this.handleEvent),ResizeSensor.detach(this.container,this.handleEvent))}}],[{key:"supportTransform",value:function(t){var i=!1,e=t?"perspective":"transform",n=e.charAt(0).toUpperCase()+e.slice(1),o=document.createElement("support").style;return(e+" "+["Webkit","Moz","O","ms"].join(n+" ")+n).split(" ").forEach(function(t,e){if(void 0!==o[t])return i=t,!1}),i}},{key:"eventTrigger",value:function(t,e,i){try{var n=new CustomEvent(e,{detail:i})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,i)}t.dispatchEvent(n)}},{key:"extend",value:function(t,e){var i={};for(var n in t)void 0!==e[n]?i[n]=e[n]:i[n]=t[n];return i}},{key:"offsetRelative",value:function(t){var e={left:0,top:0};do{var i=t.offsetTop,n=t.offsetLeft;isNaN(i)||(e.top+=i),isNaN(n)||(e.left+=n),t="BODY"===t.tagName?t.parentElement:t.offsetParent}while(t);return e}},{key:"addClass",value:function(t,e){c.hasClass(t,e)||(t.classList?t.classList.add(e):t.className+=" "+e)}},{key:"removeClass",value:function(t,e){c.hasClass(t,e)&&(t.classList?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\b)"+e.split(" ").join("|")+"(\\b|$)","gi")," "))}},{key:"hasClass",value:function(t,e){return t.classList?t.classList.contains(e):new RegExp("(^| )"+e+"( |$)","gi").test(t.className)}},{key:"defaults",get:function(){return n}}]),c}());t.default=i,window.StickySidebar=i})(e)}(e={exports:{}},e.exports),e.exports),o=(i=n)&&i.__esModule&&Object.prototype.hasOwnProperty.call(i,"default")?i.default:i;t.default=o,t.__moduleExports=n,Object.defineProperty(t,"__esModule",{value:!0})});

window.oaFilterException = true;

if(window.oaAlgoliaFilter){           
  window.oaFilterException = false;
}

window.oaStickySidebar = (function () {
  var selectorSticky = '.fixed-filter-box',
      selectorStickyInner = '.fixed-filter-box .sticky-filter',
      selectorStickyContainer = '.oa-shop-collection-box',
      selectorStickyDesktop = '.oa-shop-filter.oa-shop-filter__divider',
      selector = '.oa-shop-selected-filters-container';

  var sidebar;

  function isFilterVisible() {
  var el = document.querySelector(selectorStickyDesktop);
  if (!el) return false;
  return window.getComputedStyle(el).display !== 'none';
}

  function setupResizeDetector() {
    if (typeof ResizeObserver !== 'undefined') {
      var resizeTimer;
      var ro = new ResizeObserver(function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          window.oaStickySidebar.handleSizeChanged();
        }, 50);
      });
      var innerEl = document.querySelector(selectorStickyInner);
      var containerEl = document.querySelector(selectorStickyContainer);
      if (innerEl) { ro.observe(innerEl); }
      if (containerEl) { ro.observe(containerEl); }
      document.querySelectorAll(selector).forEach(function (el) { ro.observe(el); });
    } else {
      Array.prototype.slice.call(document.querySelectorAll('.oa-shop-filter__sub-heading[onclick]')).forEach(function (el) {
        el.addEventListener('click', function () {
          setTimeout(window.oaStickySidebar.handleSizeChanged, 200);
        }, { passive: true });
      });
    }
  }

  function setup() {
    if (isMobile() || !isFilterVisible()) {
      return;
    }

    var el = document.querySelector(selectorSticky);
    var elHeader = document.getElementById('oa-hdr19');

    if (!el || !elHeader) {
      return;
    } 

    sidebar = new StickySidebar(el, { 
      containerSelector: selectorStickyContainer,
      topSpacing: elHeader.offsetHeight || 0,
      resizeSensor: false 
    });

    setupResizeDetector();
  }

  function handleSizeChanged() {
    if (!sidebar) {
      return;
    }
    sidebar.updateSticky();
  }

  return {
    setup: setup,
    handleSizeChanged: handleSizeChanged
  };
})();

window.oaShopFilter = (function () {

  var containerSelector = '.oa_shop_collection';
  var headerTopSelector = '.oa-hdr19-top';
  var shopBannerTitleSelector = '.oa-shop-banner h4[data-filter-title]';
  var collectionHandle = window.location.pathname.replace(/\/collections\//, '')
  //Array of keyword to filters
  //Every new filter keyword gets pushed to the array when clicked active
  var filter = [];
  var filterString = '';
  var urlState = '';
  var collectionPath = '/collections/';

  var mf = Shopify.money_format.replace(/\{\{ amount[_,a-z]* \}\}/, '{{amount_no_decimals}}');
  var filterContainer = $('.oa-shop-selected-filters-container');
  var activeWearFilterListSelector = '.oa-shop-filter__list';

  var mainFilterClass = $(".mainFilterClass");
  var collisionPartnerMain = $("#oa-shop-filter__main");
  var collisionPartnerSub = $(".oa-shop-filter--desktop");

  var mainFilterAll = $('.oa-shop-filter .oa-shop-filter__wrapper:not(#oa-shop-filter__fashion-category-new) [data-all="all"]');
  var filterCount = $('.filter-options-count');

  var categoryFilters = [];
  var activeFilterListElements;
  var displayActiveFilters = false;
  var nonRemovableActiveFilters = [];
  // Campaign landing filters stay applied but cannot be unchecked. Rebuilt from the URL rather
  // than appended to, so back/forward off the campaign URL drops it again.
  function seedNonRemovableFromStates(states) {
    nonRemovableActiveFilters = states.indexOf('black-friday-sale') !== -1 ? ['black-friday-sale'] : [];
  }

  var groupToParamKey = {
    category: 'category', size: 'size', color: 'color',
    collection: 'collection', activity: 'activity', drops: 'drops',
    other: 'other', braCoverage: 'bra_coverage', legLength: 'leg_length',
    sale: 'sale', discount: 'discount', blackfriday: 'blackfriday', gains: 'gains'
  };
  var paramKeyToGroup = {};
  Object.keys(groupToParamKey).forEach(function(g) { paramKeyToGroup[groupToParamKey[g]] = g; });
  var allParamKeys = Object.keys(paramKeyToGroup);

  // Reads ?size= URL values once per call. Used as a deep-link first-paint fallback by
  // getFilterGroup before the dynamic accessory-size DOM nodes have been injected.
  function isAccessorySizeFromUrl(value) {
    try {
      var sizeParam = new URLSearchParams(window.location.search).get('size');
      if (!sizeParam) return false;
      var apparelSet = (window.filterSettingsFashion && window.filterSettingsFashion.size) || [];
      if (apparelSet.indexOf(value) !== -1) return false;
      var urlSizes = sizeParam.split('+').map(function (v) { return decodeURIComponent(v).trim(); });
      return urlSizes.indexOf(value) !== -1;
    } catch (e) { return false; }
  }
  window.oaIsAccessorySizeFromUrl = isAccessorySizeFromUrl;

  function getFilterGroup(item) {
    var settings = window.filterSettingsFashion || {};
    if (Array.isArray(settings.size) && settings.size.includes(item)) return 'size';
    // Dynamically-injected accessory sizes ("one size", "8-10") route as 'size'. DOM lookup
    // covers the post-sync case; URL fallback covers deep-link first-paint where sync hasn't run.
    if (typeof item === 'string' && item.length) {
      try {
        if (document.querySelector('#oa-shop-filter__fashion-size [data-id="' + CSS.escape(item) + '"][data-facet]')) {
          return 'size';
        }
      } catch (e) { /* CSS.escape unavailable — fall through */ }
      if (isAccessorySizeFromUrl(item)) return 'size';
    }
    if (Array.isArray(settings.activity) && settings.activity.includes(item)) return 'activity';
    if (Array.isArray(settings.color) && settings.color.includes(item)) return 'color';
    if (Array.isArray(settings.category) && settings.category.includes(item)) return 'category';
    if (Array.isArray(settings.collection) && settings.collection.includes(item)) return 'collection';
    if (Array.isArray(settings.sale) && settings.sale.includes(item)) return 'sale';
    if (Array.isArray(settings.blackfriday) && settings.blackfriday.includes(item)) return 'blackfriday';
    if (Array.isArray(settings.discount) && settings.discount.includes(item)) return 'discount';
    if (Array.isArray(settings.braCoverage) && settings.braCoverage.includes(item)) return 'braCoverage';
    if (Array.isArray(settings.legLength) && settings.legLength.includes(item)) return 'legLength';
    if (Array.isArray(settings.drops) && settings.drops.includes(item)) return 'drops';
    if (Array.isArray(settings.gains) && settings.gains.includes(item)) return 'gains';
    if (Array.isArray(settings.other) && settings.other.includes(item)) return 'other';
    return 'other';
  }

  // The entry-point filter lives in the URL path (e.g. /shop/leggings, /shop/unifiedmove, /shop/lift).
  // Tracked so it stays in the path across filter changes.
  var entryPointFilter = '';
  // Colors and sizes are URL-path filters that should still count as "applied filters"
  // (badge + pill) — everything else (category, collection, activity, drops, sale, etc.)
  // is implicit in the URL and gets excluded from the count.
  var nonEntryPointGroups = ['color', 'size'];
  function isEntryPointEligible(value) {
    return !!value && nonEntryPointGroups.indexOf(getFilterGroup(value)) === -1;
  }

  function isCategoryValue(value) {
    return getFilterGroup(value) === 'category';
  }

  // A category is the entry point only while it is the only one selected. Once a second joins,
  // both are ordinary ?category=a+b filters that have to OR — an entry point ANDs its value
  // against the rest and hides the pane you would need to undo it.
  function activeEntryPointFilter() {
    if (!isEntryPointEligible(entryPointFilter)) return '';
    if (isCategoryValue(entryPointFilter) && filter.filter(isCategoryValue).length > 1) return '';
    return entryPointFilter;
  }

  // The path segment of the URL. A non-category entry point (/shop/lift) always owns it;
  // categories follow the slider's single-select shape instead, so one selected category owns
  // the path whether it was loaded there or just clicked, and two or more leave it empty.
  function getEntryPointPath(filterArray) {
    var ep = activeEntryPointFilter();
    if (ep && !isCategoryValue(ep)) return ep;
    var cats = (filterArray || filter).filter(isCategoryValue);
    return cats.length === 1 ? cats[0] : '';
  }

  // Builds query string from filters, EXCLUDING the entry-point filter (that goes in the path)
  function filtersToQueryString(filterArray) {
    var epFilter = getEntryPointPath(filterArray);
    var grouped = {};
    (filterArray || []).forEach(function(item) {
      if (!item || item === '') return;
      // Skip the entry-point filter — it belongs in the URL path
      if (item === epFilter) return;
      var group = getFilterGroup(item);
      var key = groupToParamKey[group] || 'other';
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(item);
    });
    var params = new URLSearchParams();
    Object.keys(grouped).forEach(function(key) {
      params.set(key, grouped[key].join('+'));
    });
    var qs = params.toString();
    return qs ? '?' + qs : '';
  }

  // Reads non-entry-point filters from query params
  function queryStringToFilters() {
    var params = new URLSearchParams(window.location.search);
    var result = [];
    allParamKeys.forEach(function(key) {
      var val = params.get(key);
      if (val) {
        val.split('+').forEach(function(v) {
          var decoded = decodeURIComponent(v).trim();
          if (decoded) result.push(decoded);
        });
      }
    });
    return result;
  }

  var shop_lang = window.location.pathname.split('/')[0] !== '' && window.location.pathname.split('/')[0] !== 'de' ? window.location.pathname.split('/')[0].toUpperCase() : 'EN'

  var color_translation={
    EN:{black:'Black',blue:'Blue', brown:'Brown', green:'Green', grey:'Gray', pink:'Pink', purple:'Purple', red:'Red', orange: 'Orange', yellow:'Yellow', white:'White'},
    DE:{black:'Schwarz ',blue:'Blau ', brown:'Braun', green:'Grün', grey:'Grau', pink:'Rosa', purple:'Violett', red:'Rot', orange: 'Orange', yellow:'Gelb', white:'Weiß'},
    FR:{black:'Noir',blue:'Blue', brown:'Marron', green:'Vert', grey:'Gris', pink:'Rose', purple:'Violet', red:'Rouge', orange: 'Orange', yellow:'Yellow', white:'Blanc'},
    ME:{black:'Black',blue:'Blue', brown:'Brown', green:'Green', grey:'Gray', pink:'Pink', purple:'Purple', red:'Red', orange: 'Orange', yellow:'Yellow', white:'White'},
  };
  var fashion_sizes = ['xs', 's', 'm', 'l', 'xl', 'xxl'];
  var discount_values_fashion = ['20off', '30off', '40off', '50off', '60off', '70off','spring-clearance'];
  var discount_values_fashion_sale = ['spring-sale-bestseller', 'spring-sale-leggings', 'spring-sale-shorts', 'spring-sale-coats', 'spring-sale-tops','spring-sale-hoodies', 'spring-sale-joggers', 'spring-sale-underwear','spring-sale-accessories'];
  var discount_values_fashion_other = ['black-friday-sale', 'classic-capsule', 'krissys-style-edit','last-chance','outlet', 'buy-3-save-15', 'black-friday', 'focus-capsule', 'everybody-capsule', 'raw-lounge-capsule', 'spring-sale', 'spring-sale-bestseller', 'new', 'best-seller', 'one-more-rep','12-days-of-oner', 'mia-green', 'active-rest-day', 'accentuate', 'brenda-anton', 'hybrid-launch', 'strong-yet-soft', 'pause-and-recharge', 'always-in-oner', 'set-the-tone', 'strong-is-a-statement', 'outlet', 'oner-your-body', 'oner-your-body-through-movement', 'blackberry-purple-collection'];
  var discount_values_fashion_gains = ['day-1', 'day-2', 'day-3', 'day-4', 'day-5', 'day-6','day-7', 'day-8', 'day-9', 'day-10', 'day-11', 'day-12'];
  var discount_translation={
    EN:{discount:'Discount'},
    DE:{discount:'Rabatt'},
    FR:{discount:'de réduction'},
    ME:{discount:'Discount'},
  };
  var discount_translation_gains={
    EN:{day:'Day'},
    DE:{day:'Tag'},
  };

  var urlStatePath = window.location.pathname.split('/').filter(function (p) { return p.length > 0; }).pop();

  if(collectionHandle.indexOf('/en') > -1 && window.location.host == 'me.oneractive.com'){
    collectionHandle = collectionHandle.replace('/en','').split(/\//).shift();
    collectionPath = '/en/collections/';
  }else{
    collectionHandle = collectionHandle.split(/\//).shift();
  }

  // Filter URL initialization: category from path, other filters from query params
  // URL format: /collections/shop/leggings?color=red&size=s
  // Entry-point filter is in the path, additional filters in query params
  var pathFilter = (urlStatePath != collectionHandle) ? urlStatePath : '';

  // A lone ?category= value on load is the entry point: navigate to the canonical path so
  // /collections/shop?category=leggings renders exactly like /collections/shop/leggings.
  // A real navigation, not replaceState — the top of the PLP (category slider, promo banner,
  // SEO block) is gated server-side on request.path, which only a fresh request can change.
  // Load only: in-session URLs are rebuilt from filter[] by getEntryPointPath().
  // Path-prefix guard keeps /search?category= (its own handler) out of this.
  if (!pathFilter && window.location.pathname.indexOf(collectionPath) === 0) {
    var catParams = new URLSearchParams(window.location.search);
    // Split on both encodings of the multi-value separator: get() decodes %2B to '+'
    // and a literal '+' to a space.
    var catValues = (catParams.get('category') || '').split(/[+ ]/)
      .map(function (v) { return v.trim(); }).filter(Boolean);
    // Equal to the handle would mean /collections/leggings/leggings — no entry point to gain.
    if (catValues.length === 1 && catValues[0] !== collectionHandle) {
      catParams.delete('category');
      var restQs = catParams.toString();
      window.location.replace(
        collectionPath + collectionHandle + '/' + catValues[0] + (restQs ? '?' + restQs : ''));
    }
  }

  var qsFilters = queryStringToFilters();
  var hasLegacyMultiPath = pathFilter && pathFilter.indexOf('+') !== -1;

  if (hasLegacyMultiPath) {
    // Legacy URL: /collections/shop/leggings+red+s → /collections/shop/leggings?color=red&size=s
    var legacyFilters = pathFilter.split('+');
    // First filter becomes the entry point in the path
    entryPointFilter = legacyFilters[0];
    var legacyQs = filtersToQueryString(legacyFilters);
    var legacyBasePath = collectionPath + collectionHandle + '/' + entryPointFilter;
    urlState = pathFilter;
    window.history.replaceState(null, '', legacyBasePath + legacyQs);
  } else {
    // New format: entry-point from path, other filters from query params
    if (pathFilter) entryPointFilter = pathFilter;
    var allFilters = [];
    if (pathFilter) allFilters.push(pathFilter);
    allFilters = allFilters.concat(qsFilters);
    if (allFilters.length > 0) {
      urlState = allFilters.join('+');
    } else {
      mainFilterAll.addClass('checked');
    }
  }

var priceFilter = (function () {

    
    var sliders = document.querySelectorAll(".range-slider input[type='range']");
    var thumbs = document.querySelectorAll(".range-slider .thumb");
    var range = document.querySelectorAll(".range-slider .range");
    var rangeValues = document.querySelectorAll(".rangeValues");
    var priceRmin = null;
    var priceRmax = null;
    var priceRangeIndex = null;
    var children = null;

    function isInitialized() {
      return sliders && sliders.length > 0;
    }

    function isPriceInRange(item) {
      return item.dataset.price >= priceRmin && item.dataset.price <= priceRmax;
    }

    function isActive () {
      // for (let i = 0; i < sliders.length; i += 2) {
      //   if (!((priceRmin/100) == sliders[i].min && (priceRmax/100) == sliders[i+1].max)) {
      //     return true;
      //   }
      // }
      // return false;
      let i = priceRangeIndex - (priceRangeIndex % 2); // ensure even index (start of pair)
      return !((priceRmin/100) == sliders[i].min && (priceRmax/100) == sliders[i + 1].max);
    }

    function setMinMax(min, max){
      priceRmin = min;
      priceRmax = max;
    }

    function setPriceRangeText() {
      rangeValues = document.querySelectorAll(".rangeValues");
      rangeValues.forEach(function(el) {
        el.innerHTML = getPriceValuesText();
      });
    }

    function getPriceValuesText() {
      var min = Shopify.formatMoney(priceRmin, mf);
      var max = Shopify.formatMoney(priceRmax, mf);
      var text = "<div>" + min + "</div>" + "<div> – </div>" + "<div>" + max + "</div>";
      return text.replace(/\s/g, '&nbsp;');
    }

    function getPriceRangeValues() {
      let slide1, slide2, tL, tR;
      // Use the current priceRangeIndex to determine which slider pair to use
      let pair = priceRangeIndex !== null && priceRangeIndex !== undefined ? Math.floor(priceRangeIndex / 2) : 0;
      let minIndex = pair * 2;
      let maxIndex = minIndex + 1;

      slide1 = parseFloat(sliders[minIndex].value * 100);
      slide2 = parseFloat(sliders[maxIndex].value * 100);
      tL = thumbs[minIndex].style.left;
      tR = thumbs[maxIndex].style.left;

      if (slide1 > slide2) {
      // Swap values and thumb positions if needed
      [slide1, slide2] = [slide2, slide1];
      [tL, tR] = [tR, tL];
      }

      // Update range bar style for all pairs
      for (let i = 0; i < range.length; i++) {
      let left = parseInt(tL);
      let right = parseInt(tR);
      range[i].style.left = left + '%';
      range[i].style.width = Math.abs(right - left) + '%';
      }

      setMinMax(slide1, slide2);
      setPriceRangeText();
      return [slide1, slide2];
    }
    function resetPriceRangeValues(noRangeAndThumbs) {
      setMinMax(null, null);
      if (noRangeAndThumbs !== true && sliders.length >= 6) {
        sliders[0].value = sliders[0].min;
        sliders[1].value = sliders[1].max;
        sliders[2].value = sliders[2].min;
        sliders[3].value = sliders[3].max;
        sliders[4].value = sliders[4].min;
        sliders[5].value = sliders[5].max;

        range[0].style.left = '0%';
        range[1].style.left = '0%';
        range[2].style.left = '0%';
        range[0].style.width = '100%';
        range[1].style.width = '100%';
        range[2].style.width = '100%';

        thumbs[0].style.left = '0%';
        thumbs[2].style.left = '0%';
        thumbs[4].style.left = '0%';
        thumbs[1].style.left = '100%';
        thumbs[3].style.left = '100%';
        thumbs[5].style.left = '100%';
      }
      getPriceRangeValues();
      setPriceRangeText();
      if (!window.__oaSuppressFilterCallback) {
        document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter: oaShopFilter.getFilter(), filtermin: 99999, filtermax: 99999 } }));
      }
    }

    function handlePriceSlider(el) {
      if(!el) {return;}
      var ctx = el;
      sliders.forEach(function (s, index) {
        priceRangeIndex = index;
        if (ctx === sliders[priceRangeIndex]) {
          if (index < 2) {
            sliders[2].value = sliders[0].value;
            sliders[3].value = sliders[1].value;
            sliders[4].value = sliders[0].value;
            sliders[5].value = sliders[1].value;
          } else if (index < 4) {
            sliders[0].value = sliders[2].value;
            sliders[1].value = sliders[3].value;
            sliders[4].value = sliders[2].value;
            sliders[5].value = sliders[3].value;
          } else {
            sliders[0].value = sliders[4].value;
            sliders[1].value = sliders[5].value;
            sliders[2].value = sliders[4].value;
            sliders[3].value = sliders[5].value;
          }

          var value = (100 / (parseInt(ctx.max) - parseInt(ctx.min))) * parseInt(ctx.value) - (100 / (parseInt(ctx.max) - parseInt(ctx.min))) * parseInt(ctx.min);
          children = ctx.parentNode.childNodes[1].childNodes;
          if (index == 0 || index == 2 || index == 4) {
            thumbs[0].style.left = value + '%';
            thumbs[2].style.left = value + '%';
            thumbs[4].style.left = value + '%';
            range[0].style.left = value + '%';
            range[1].style.left = value + '%';
            range[2].style.left = value + '%';
            range[0].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
            range[1].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
            range[2].style.width = Math.abs(parseInt(thumbs[1].style.left) - value) + '%';
          } else {
            thumbs[1].style.left = value + '%';
            thumbs[3].style.left = value + '%';
            thumbs[5].style.left = value + '%';
            range[0].style.left = thumbs[2].style.left;
            range[1].style.left = thumbs[2].style.left;
            range[2].style.left = thumbs[2].style.left;
            range[0].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
            range[1].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
            range[2].style.width = Math.abs(value - parseInt(thumbs[2].style.left)) + '%';
          }
          return;
        }
      });
      getPriceRangeValues();
    }

    function init() {
      if (!isInitialized()) { return; }
      handlePriceSlider();
    }

    function getSliders() {
      return sliders;
    }

    return {
      init: init,
      isInitialized: isInitialized,
      isPriceInRange: isPriceInRange,
      isActive: isActive,
      handlePriceSlider: handlePriceSlider,
      getPriceValuesText: getPriceValuesText,
      resetPriceRangeValues: resetPriceRangeValues,
      getSliders: getSliders,
      getPriceRangeValues: getPriceRangeValues,
    };
  })();

  function animatedScrollTop() {
    var target = document.querySelector('.oa-shop-products-collection');
    if (!target) return;
    var headerTop = document.querySelector(headerTopSelector);
    var offset = (headerTop ? headerTop.clientHeight : 0) + 80;
    var targetTop = target.getBoundingClientRect().top + window.scrollY - offset;
    // Only scroll if user is already past the target element
    if (window.scrollY > targetTop) {
      $('html, body').stop().animate({ scrollTop: targetTop }, 225);
    }
  }


  function initCategoryFilter(categories) {

    if (categories && categories.length > 0) {
      categoryFilters = categories;
    }
    updateDynamicFilterHeadings();
  }

  function isFilterListEmpty () {
    return activeFilterListElements.every(el => el.querySelectorAll('li').length < 1);
  }

  function isCategoryInFilter(cf) {
    return filter.some(function(v) { 
      cf.includes(v);
    });
  }

  function getShopLang () {
    var l = window.location.host.split('.')[0];
    if(l === 'de') {
      return l.toUpperCase();
    } else {
      return 'EN';
    }
  }
  
  function createRemoveIcon() {
    var icon = document.createElement("div");
    icon.className = "remove-icon";
    icon.innerHTML = `<svg aria-hidden="true" focusable="false" role="img" viewBox="0 0 10 10" width="10" height="10" fill="none"><path d="M0.901769 0.458065C0.67065 0.690323 0.487114 0.903226 0.500709 0.935484C0.514305 0.96129 1.42518 1.87742 2.5264 2.96774C3.62761 4.05806 4.53849 4.96774 4.55209 4.99355C4.55889 5.01935 3.68879 5.90323 2.61477 6.96774C1.53395 8.02581 0.616269 8.94839 0.561888 9.01935C0.480317 9.13548 0.507507 9.18065 0.922162 9.56774L1.3708 10L1.71748 9.67742C1.90782 9.49677 2.83229 8.59355 3.77036 7.65806L5.47656 5.96129L6.8021 7.27097C7.52944 7.99355 8.46072 8.89677 8.86177 9.29032L9.58912 10L10.0378 9.58065C10.2825 9.35484 10.4796 9.14194 10.4796 9.10968C10.4796 9.05806 10.0038 8.58065 7.6382 6.23871L6.38744 5L7.66539 3.72258C8.36555 3.02581 9.29002 2.11613 9.71827 1.69677L10.5 0.948387L10.2893 0.696774C10.1805 0.561291 9.96979 0.348388 9.83383 0.225806L9.58912 0L9.16767 0.419355C8.93655 0.651613 8.01207 1.55484 7.12159 2.43871L5.49016 4.03871L5.0891 3.66452C4.87158 3.45806 3.9539 2.55484 3.05661 1.65806C2.15253 0.767742 1.3912 0.032258 1.36401 0.032258C1.34361 0.032258 1.13289 0.225806 0.901769 0.458065Z" fill="currentColor"/></svg>`;
    return icon;
  }
  
  function isFilterNonRemovable(id) {
    if (!id) {
      return false;
    }
    return nonRemovableActiveFilters.length > 0 && nonRemovableActiveFilters.includes(id);
  }

  function appendLi(categoryFilter, f, li, checkbox, text) {
    // Resolve the live checkbox lazily — the captured one may have been an empty jQuery set
    // when this pill was created (e.g. dynamic accessory size injected by syncAccessorySizeCheckboxes
    // after the pill was rendered from URL state).
    function clickCheckbox() {
      var live = checkbox && checkbox.length
        ? checkbox
        : $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__wrapper label[data-id="' + f + '"]').first();
      if (live && live.length) live.click();
    }
    let found = false;
    activeFilterListElements.forEach(function (listEl) {
      const items = listEl.querySelectorAll('li[data-id="' + f + '"]');
      if (items.length > 0) {
        found = true;
        items[0].addEventListener("click", function (event) {
          event.preventDefault();
          clickCheckbox();
          li.remove();
          if (isFilterListEmpty()) {
            filterContainer.addClass("hidden");
            if (isCategoryInFilter(categoryFilter)) {
              mainFilterAll.addClass("checked");
            }
          }
        });
      }
    });
    if (found) {
      console.log("Filter already exists in active filter list:", f);
      return;
    }

    // TODO: If this is changed, categories are also displayed, but the logix for the active filter.
    // if (categoryFilter.indexOf(f) == -1) {
    // The sale launch tag is the shop-all of the sale — treat it like 'all' and never render a pill for it.
    if (f !== 'all' && !(window.oaIsSaleActive && f === window.oaCountdownLaunchTag)) {
      let txt = document.createElement('span');
      txt.classList.add('oa-shop-filter__list__text');
      if (text) {
        txt.appendChild(document.createTextNode(text.replace(/ *\([^)]*\) */g, "")));
      } else {
        txt.appendChild(document.createTextNode(color_translation[getShopLang()][f]));
      }
      li.appendChild(txt);

      li.setAttribute("data-id", f);
      if (isFilterNonRemovable(f)) {
        li.classList.add('non-removable');
      } else {
        li.appendChild(createRemoveIcon());
      }
      li.addEventListener("click", function (event) {
        event.preventDefault();
        if (li.classList.contains('non-removable')) {
          return;
        }
        clickCheckbox();
        li.remove();
        if (isFilterListEmpty()) {
          filterContainer.addClass("hidden");
          if (isCategoryInFilter(categoryFilter)) {
            mainFilterAll.addClass("checked");
          }
        }
      });

      activeFilterListElements.forEach(function (listEl) {
        listEl.appendChild(li.cloneNode(true));
      });
      if (filterContainer.hasClass("hidden")) {
        filterContainer.removeClass("hidden");
      }
    }
  }

  function addFilterToList(f) {
    if (!displayActiveFilters) {
      return;
    }
    if (f === '*' || !f) {

      return; 
    }
    if (displayActiveFilters && !activeFilterListElements) {
      activeFilterListElements = Array.from(document.querySelectorAll(activeWearFilterListSelector));
    }


    var checkbox = $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__wrapper label[data-id="'+f+'"]').first();
    var text = checkbox.text();
    categoryTitle = checkbox.closest('.oa-shop-filter__wrapper').find('.oa-shop-filter__sub-heading').text();
    // Fallback for dynamic accessory sizes whose checkbox is injected later by
    // syncAccessorySizeCheckboxes — derive the label from the value and the heading from
    // the size wrapper so the active-filter pill renders correctly on first paint.
    if (checkbox.length === 0 && typeof window.oaIsAccessorySizeFromUrl === 'function' && window.oaIsAccessorySizeFromUrl(f)) {
      text = String(f).split(/\s+/).map(function (w) {
        return /[a-z]/i.test(w) ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w;
      }).join(' ');
      categoryTitle = $('#oa-shop-filter__fashion-size .oa-shop-filter__sub-heading').first().text();
    }
    var li = document.createElement('li');
    // if(fashion_sizes.includes(f)) { text = f.toUpperCase(); }
    if(discount_values_fashion.includes(f)) { 
      text = f.replace('off', '% '+discount_translation[getShopLang()]['discount']); 
    } //ToDo translation

    const offValues = [
      10,
      20,
      30,
      40,
      50,
      60,
    ];
    for (let offValue of offValues) {
      if (text.includes(offValue+'%') || f.includes(offValue+'off')) {
        if (getShopLang() === 'EN') {
          text = `${offValue}% off`;
        } else {
          text = `-${offValue}%`;
        }
      }  
    }

    if (discount_values_fashion_other.indexOf(f) !== -1) {
      switch (f) {
        case 'black-friday':
          text = 'Black Friday';
          break;
        case 'classic-capsule':
          text = 'Classic Capsule';
          break;
        case 'krissys-style-edit':
          text = "Krissy's Style Edit";
          break;
      }
    }    

    var selectedFilterTitle = '';
    if (isMobile()) {
      selectedFilterTitle = text;
    } else {
      selectedFilterTitle = categoryTitle + ': ' + text;
    }

    appendLi(categoryFilters, f, li, checkbox, selectedFilterTitle);

  }

  function getFilteredItemCount() {
    if(!window.oaFilterException){return;}
  }

  function appendFilter(f) { 
    if (!f) {
      return;
    }
    if (filter.includes(f)) {
      return;
    }
    filter.push(f); 
    addFilterToList(f);
    return filter;
  }

  function appendFilterString(fs) { 
    if (fs) {
      filterString += fs; 
    }
    return filterString;
  }

  function getFirstFilterStringPart() {
    var parts = filterString.split('.').filter(function (part) { return part.trim().length > 0; });
    if (parts.length === 1) {
      return parts[0];
    }
    return null;
  }

  function getAllFilterStringParts() {
    var parts = filterString.split('.').filter(function (part) { return part.trim().length > 0; });
    if (parts.length > 0) {
      return parts.join('+');
    }
    return null;
  }

  function updateShopBannerTitle() {
    
    var shopBannerTitle = document.querySelector(shopBannerTitleSelector);
    
    if (!shopBannerTitle) {
      return; 
    }
    var filterPart = getFirstFilterStringPart();
    if(filterPart == 'spring-clearance'){return;}
    if (filterPart) {
      var label = document.querySelector('.oa-shop-filter__checkbox[data-id="'+filterPart+'"]');
      if (label && label.hasAttribute('data-banner-title')) {
        var langFilterText = label.innerText;
        shopBannerTitle.innerHTML = langFilterText;
      }
    } else {
      shopBannerTitle.innerHTML = shopBannerTitle.getAttribute('data-initial-content');
    }
  }

  function updateDynamicFilterHeadings() {
    $('.oa-shop-filter__wrapper').each(function () {
      var $wrapper = $(this);
      var $heading = $wrapper.find('.oa-shop-filter__sub-heading[data-dynamic-heading]').first();

      if (!$heading.length) {
        return;
      }

      // The current theme marks the sub items themselves with `hidden` or
      // `facet-hidden`, so the heading should follow those item classes.
      var $subInner = $wrapper.find('.oa-shop-filter__sub__inner-flex').first();
      var hasVisibleCheckbox = $subInner.children().filter(function () {
        return !this.hasAttribute('data-all') &&
          !$(this).hasClass('hidden') &&
          !$(this).hasClass('facet-hidden');
      }).length > 0;

      $heading.toggleClass('hidden', !hasVisibleCheckbox);
    });
  }

  function countItems(){
    // .filter-result-count is now populated by setCurrentProductCount in algolia-collection.liquid
    // (using Algolia's total nbHits, not the per-page hits.length cap).
    if(!window.oaAlgoliaFilter){
      var filteredItems = getFilteredItemCount();
      $('.filter-result-count').text('('+filteredItems+')');
      $('.filter-result-count-desk').text(filteredItems);
    }
    window.oaShopFilter.updateOptionsCount();
    if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
      $('.oa-filter-sidebar-wrapper .oa-side-filter-footer').css('bottom','50px;');
    }
  }

  function removeFilter(key){
    var index = filter.indexOf(key);
    if (index > -1) {
      filter.splice(index, 1);
    }

    if (key === 'pricerange') {
      priceFilter.resetPriceRangeValues();
    }

    if (key === 'selected-sort') {
      window.oaShopSort.resetSortFilter();
    }
  
    if(isFilterListEmpty()) {
      filterContainer.addClass('hidden');
      if(isCategoryInFilter(categoryFilters)) {
        mainFilterAll.addClass('checked');
      }
    }
  }

  function isChecked($this){
    if ($this.hasClass('checked')) {
      return true;
    } else {
      return false
    }
  }

  function setFilter(f) { 
    filter = [];
    for (var i = 0; i < f.length; i++) {
      appendFilter(f[i]); 
    }
  }

  function getFilteredItemsWithouPrice() {
    var filters = window.oaShopFilter.getFilter();
  }

  function updateMinMaxPriceFromFilteredItems() {
    return;

    var minPrice;
    var maxPrice;
    getFilteredItemsWithouPrice().forEach(function (item) {
      var price = parseInt(item.element.dataset.price);
      if (isNaN(price)) {
        return;
      }
      price = price / 100;
      if (typeof minPrice === 'undefined') {
        minPrice = Math.floor(price);
      }
      if (typeof maxPrice === 'undefined') {
        maxPrice = Math.ceil(price); 
      }
      if (price < minPrice) {
        minPrice = Math.floor(price);
      }
      if (price > maxPrice) {
        maxPrice = Math.ceil(price); 
      }
    });
    setPriceMinMaxValues(minPrice, maxPrice);
  }


  function filterCallback () {
    countItems();
    updateShopBannerTitle();
    updateMinMaxPriceFromFilteredItems();
    algoliaFilterTracking('collectionFilter',filter);
    updateDynamicFilterHeadings();

    var filterPart = getAllFilterStringParts();
    var isSearchPage = window.location.pathname === '/search' || window.location.pathname.endsWith('/search');
    if (filterPart) {
      $('.collection-headline span.collection-head-subtext').show();
        if (!isSearchPage) {
          let epPath = getEntryPointPath();
          let basePath = collectionPath + collectionHandle + (epPath ? '/' + epPath : '');
          let queryString = filtersToQueryString(filter);
          let newUrl = basePath + queryString;
          if (window.location.pathname + window.location.search !== newUrl) {
            window.history.pushState({ filters: filter.slice() }, '', newUrl);
          }
        }
        var firstFilter = getFirstFilterStringPart();
        if (firstFilter) {
          var langFilterText = $('.oa-shop-filter__checkbox.'+firstFilter).first().text();
          $('.collection-headline span.collection-head-subtext').text(langFilterText);
        }
    } else {
        $('.collection-headline span.collection-head-subtext').hide();
        if (!isSearchPage) {
          let epPath = getEntryPointPath();
          let newUrl = collectionPath + collectionHandle + (epPath ? '/' + epPath : '');
          if (window.location.pathname + window.location.search !== newUrl) {
            window.history.pushState(null, '', newUrl);
          }
        }
    }


    document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter:filter}}));
  }

  function filterItems(el) {
    if(filterString) {
      return filter.every(function(f) {
        return el.classList.contains(f);
      }) && priceFilter.isPriceInRange(el);
    } else {
      return priceFilter.isPriceInRange(el);
    }
  }

  var groupClassMap = {
    'oa-shop-filter__checkbox-color': 'color',
    'oa-shop-filter__checkbox-size': 'size',
    'oa-shop-filter__checkbox-category': 'category',
    'oa-shop-filter__checkbox-collection': 'collection',
    'oa-shop-filter__checkbox-activity': 'activity',
    'oa-shop-filter__checkbox-drop': 'drops',
    'oa-shop-filter__checkbox-other': 'other',
    'oa-shop-filter__checkbox-bracoverage': 'bracoverage',
    'oa-shop-filter__checkbox-leglength': 'legLength',
    'oa-shop-filter__checkbox-discount': 'discount',
    'oa-shop-filter__checkbox-blackfriday': 'blackfriday',
    'oa-shop-filter__checkbox-sale': 'sale',
    'oa-shop-filter__checkbox-gains': 'gains'
  };

  function getGroupNameFromCheckbox($el) {
    var classes = ($el.attr('class') || '').split(/\s+/);
    for (var i = 0; i < classes.length; i++) {
      if (groupClassMap[classes[i]]) return groupClassMap[classes[i]];
    }
    return null;
  }

  var dynamicFilterRules = [
    { key: 'braCoverage', parents: ['bras'], selector: '.oa-shop-filter__checkbox-bracoverage' },
    { key: 'legLength', parents: ['leggings', 'wide-leg-bottoms', 'joggers', 'bodysuits'], selector: '.oa-shop-filter__checkbox-leglength' },
    // Accessory sizes are dynamically injected by syncAccessorySizeCheckboxes; their values
    // come from the live DOM rather than filterSettingsFashion. When 'accessories' is no longer
    // active, drop the values from the filter array AND remove the injected nodes.
    { key: 'accessorySize', parents: ['accessories'], selector: '.oa-shop-filter__checkbox-size--dynamic', dynamicValues: true }
  ];

  function cleanupInvalidDynamicChildren() {
    var activeSliderCategory = window.oaAlgolia && window.oaAlgolia.activeCategoryFilters;
    dynamicFilterRules.forEach(function (rule) {
      var values = rule.dynamicValues
        ? $(rule.selector).map(function () { return $(this).attr('data-id'); }).get()
        : (window.filterSettingsFashion && window.filterSettingsFashion[rule.key]);
      var hasParent = rule.parents.some(function (p) {
        return filter.includes(p) || p === activeSliderCategory;
      });
      if (!values || values.length === 0) {
        // No values to clean up, but for dynamic rules we still want to sweep stale nodes
        // when the parent is no longer active (defensive — sync helper handles the common case).
        if (rule.dynamicValues && !hasParent) $(rule.selector).remove();
        return;
      }
      if (hasParent) return;
      values.forEach(function (val) {
        if (filter.includes(val)) {
          filter = jQuery.grep(filter, function (f) { return f !== val; });
        }
        $(rule.selector + '[data-id="' + val + '"]').removeClass('checked');
        $('.oa-shop-filter__list li[data-id="' + val + '"]').remove();
      });
      if (rule.dynamicValues) $(rule.selector).remove();
    });
  }

  // A subcategory (skorts) refines its parent (skorts-and-dresses), and only the parent owns
  // a slider chip. Returns the value whose chip represents this category.
  function getCategoryChipId(value) {
    return $('.oa-shop-filter__checkbox-category-sidebar[data-id="' + value + '"]')
      .attr('data-subcategory-parent') || value;
  }

  // Applies the slider's single-select rule to the sidebar's checked state: one category ->
  // that chip, none -> "All", more than one -> no chip. Reads the DOM so every caller agrees.
  function syncCategorySliderToSidebar() {
    $('.oa-shop-filter__checkbox-category-main').removeClass('checked');
    var activeSidebarCats = [];
    // The entry-point category has no checked sidebar box (this page hid it) but is exactly what
    // the slider represents. Mapped to its parent like the scan below: /shop/skorts has no chip.
    if (entryPointFilter && categoryFilters.indexOf(entryPointFilter) !== -1) {
      activeSidebarCats.push(getCategoryChipId(entryPointFilter));
    }
    $('.oa-shop-filter__checkbox-category-sidebar.checked').each(function () {
      // Deduped because the sidebar is rendered once per breakpoint copy.
      var catId = $(this).attr('data-subcategory-parent') || $(this).attr('data-id');
      if (catId && activeSidebarCats.indexOf(catId) === -1) activeSidebarCats.push(catId);
    });
    if (activeSidebarCats.length > 1) return;
    // A category with no dedicated slider chip (e.g. summer-sale-best-sellers) falls back to "All".
    var $sliderCat = activeSidebarCats.length === 1
      ? $('.oa-shop-filter__checkbox-category-main[data-id="' + activeSidebarCats[0] + '"]')
      : $();
    if ($sliderCat.length) {
      $sliderCat.addClass('checked');
    } else {
      $('.oa-shop-filter__checkbox-category-main[data-all]').addClass('checked');
    }
  }

  // Category slider handler: always single-choice, overwrites sidebar category selections.
  // The slider acts as a quick-switch that replaces all category selections.
  function handleCategorySliderClick(e) {
    var $id = $(this).attr('data-id') || $(this).attr('data-all');
    var isAll = $(this).attr('data-all') !== undefined;

    animatedScrollTop();

    // Remove all category values from the filter array
    var cats = categoryFilters.slice();
    cats.forEach(function(cat) {
      var idx = filter.indexOf(cat);
      if (idx !== -1) filter.splice(idx, 1);
      $('.oa-shop-filter__list li[data-id="' + cat + '"]').remove();
    });

    // Uncheck all slider items and sidebar category checkboxes
    $('.oa-shop-filter__checkbox-category-main').removeClass('checked');
    $('.oa-shop-filter__checkbox-category-sidebar').removeClass('checked');

    // The slider selects, it does not navigate: the category goes to ?category= as an ordinary
    // removable filter, so the sidebar's Product Category pane stays usable. A category already
    // in the path is dropped rather than swapped; a collection/drop/activity still owns the path.
    if (categoryFilters.indexOf(entryPointFilter) !== -1) entryPointFilter = '';

    if (isAll) {
      // "All" clicked: clear category filter entirely
      window.oaAlgolia.activeCategoryFilters = '';
      mainFilterAll.addClass('checked');
    } else {
      mainFilterAll.removeClass('checked');
      window.oaAlgolia.activeCategoryFilters = $id;
      // Mark the clicked slider item as checked
      $('.oa-shop-filter__checkbox-category-main[data-id="' + $id + '"]').addClass('checked');
      // Also check the matching sidebar category checkbox
      $('.oa-shop-filter__checkbox-category-sidebar[data-id="' + $id + '"]').addClass('checked');
      // An ordinary category filter now: removable pill, counted in the badge.
      appendFilter($id);
    }

    // The category sweep above only removes pills and appendLi only un-hides the bar, so an
    // emptied list would leave "Selected filters / Clear all" showing with nothing in it.
    if ($('.oa-shop-filter__list li').length === 0) {
      $('.oa-shop-selected-filters-container').addClass('hidden');
    }

    // Apply the new entry point now, not 200ms later when filterCallback() dispatches, so the
    // panes do not lag the click.
    if (typeof window.oaRefreshFilterEntryPoint === 'function') {
      window.oaRefreshFilterEntryPoint();
    }

    setTimeout(function() {
      cleanupInvalidDynamicChildren();
      filterString = '';
      filter.forEach(function(item) {
        appendFilterString('.' + item);
      });
      filterCallback();

      if (typeof window.updateDynamicFilterVisibility === 'function') {
        var dynamicFilters = filter.slice();
        if (window.oaAlgolia.activeCategoryFilters) {
          dynamicFilters.push(window.oaAlgolia.activeCategoryFilters);
        }
        window.updateDynamicFilterVisibility(dynamicFilters);
      }
    }, 200);
  }

  function handleCheckboxClick($checkboxes, filterValues, e) {
    var $id = $(this).attr('data-id');
    var $this = $('.oa-shop-filter .oa-shop-filter__wrapper:not(#oa-shop-filter__fashion-category-new) [data-id="'+$id+'"]');
    var groupName = getGroupNameFromCheckbox($(this));
    var isMultiSelectGroup = window.filterGroupConfig && window.filterGroupConfig[groupName]
      ? window.filterGroupConfig[groupName].multiSelect
      : false;
    var isAll = false;

    //Srcoll top after Filter Selection
    animatedScrollTop();

    if($this.length < 1) {
      //$this = $('.oa-shop-filter .oa-shop-filter__wrapper label[data-all]');
      isAll = true;
    }
    if ($checkboxes && filterValues) {
      if (!isMultiSelectGroup && $checkboxes.hasClass('checked')) {
        filter = jQuery.grep(filter, function(item) {
          return !filterValues.includes(item) && item;
        });
      }
    }
    //Handle the 'checked' class on the filter labels
    if (isChecked($this)) {
      if (isFilterNonRemovable($id)) {
        return;
      }
      $this.removeClass('checked');
      $('.oa-shop-filter__list li[data-id="'+$id+'"]').remove();
      removeFilter($id);
      $('.oa-filter-string').text('');
      if(categoryFilters.indexOf($id) != -1){
        mainFilterAll.addClass('checked');
      }
    } else {
      if ($checkboxes && !isMultiSelectGroup) {
        $checkboxes.removeClass('checked');
        $checkboxes.each(function (index, checkbox) {
          $('.oa-shop-filter__list li[data-id="'+checkbox.getAttribute('data-id')+'"]').remove();
        });
      }
      $('.oa-filter-string').text('');
      $this.addClass('checked');

      appendFilter($id);
    }

    // When a sidebar category is clicked, sync the slider to reflect current state
    if (categoryFilters.indexOf($id) !== -1) {
      syncCategorySliderToSidebar();
    }

    cleanupInvalidDynamicChildren();

    if(isAll) {
      mainFilterAll.addClass('checked');
    }
    setTimeout(function() {
      if (filter) {
        filterString = '';
        var l = filter.length;
        filter.forEach(function(item, index) {
          appendFilterString('.' + item);
        });

        //Filter the Grid
      }
      filterCallback();

      // Update dynamic filter visibility based on active category
      if (typeof window.updateDynamicFilterVisibility === 'function') {
        var dynamicFilters = filter.slice();
        if (window.oaAlgolia && window.oaAlgolia.activeCategoryFilters) {
          dynamicFilters.push(window.oaAlgolia.activeCategoryFilters);
        }
        window.updateDynamicFilterVisibility(dynamicFilters);
      }

      if (isChecked($this)) {
      scrollElementIntoViewIfNeeded($id, (e && e.target.parentElement || this));
      } else if (isChecked(mainFilterAll)) {
        var mainFilterAll2 = $('#oa-shop-filter__main .oa-shop-filter [data-all="all"]');
        scrollElementIntoViewIfNeeded(mainFilterAll2.data('all') || mainFilterAll2.data('id'), mainFilterAll2.get(0));
      }
    }, 200);

    
function getFilters(input) {
    const filterSettings = window.filterSettingsFashion;

    const filters = {
        size: null,
        activity: null,
        color: null,
        category: null,
        collection: null,
        other: null
    };

    input.forEach(item => {
        if (filterSettings.size.includes(item)) {
            filters.size = item;
        } else if (filterSettings.activity.includes(item)) {
            filters.activity = item;
        } else if (filterSettings.color.includes(item)) {
            filters.color = item;
        } else if (filterSettings.collection.includes(item)) {
            filters.collection = item;
        } else if (filterSettings.other.includes(item)) {
            filters.other = item;
        } else if (filterSettings.category.includes(item)) {
            filters.category = item;
        }
    });

    return { filters };
}

   Shopify.analytics.publish("filter_applied_custom", 	getFilters(filter));
   //console.log(getFilters(filter));
    
  }

  function updatePriceMinMax(slider, min, max) {
    if (typeof slider.dataset.min === 'undefined') {
      slider.dataset.min = slider.min;
    }
    if (typeof slider.dataset.max === 'undefined') {
      slider.dataset.max = slider.max;
    }

    //     var xMin = parseInt(priceRmin/100);
    //     var xMax = parseInt(priceRmax/100);
    //     if (isPriceFilterSet()) {
    //       if (typeof min !== 'undefined' && xMin < min) {
    //         min = xMin;
    //       }
    //       if (typeof max !== 'undefined' && xMax > max) {
    //         max = xMax;
    //       }
    //     }

    slider.min = typeof min !== 'undefined' ? min : slider.dataset.min;
    slider.max = typeof max !== 'undefined' ? max : slider.dataset.max;
    if (parseInt(slider.value) < parseInt(slider.min)) {
      slider.value = slider.min; 
    } else if (parseInt(slider.value) > parseInt(slider.max)) {
      slider.value = slider.max; 
    }
  }

  function getSlideValue(slide) {
    return (100/(parseInt(slide.max)-parseInt(slide.min)))*parseInt(slide.value)-(100/(parseInt(slide.max)-parseInt(slide.min)))*parseInt(slide.min);
  }

  function updateThumbsAndRanges(min, max) {
    for (var i = 0; i < thumbs.length; i+=2) {
      var thumb1 = thumbs[i];
      var thumb2 = thumbs[i + 1];
      thumb1.style.left = min+'%';
      thumb2.style.left = max+'%';
    }
    for (var i = 0; i < range.length; i++) {
      range[i].style.left = min+'%';
      range[i].style.width = Math.abs(max-min)+'%';
    } 
  }

  function setPriceMinMaxValues(min, max) {
    if (typeof min !== 'undefined' && typeof max !== 'undefined' && sliders[0].min == min && sliders[0].max == max) {
      return; 
    }

    for (var i = 0; i < sliders.length; i+=2) {
      var slide1 = sliders[i];
      var slide2 = sliders[i + 1];
      updatePriceMinMax(slide1, min, max);
      updatePriceMinMax(slide2, min, max);
      if (parseInt(slide1.value) == parseInt(slide2.value)) {
        slide1.value = slide1.min;
        slide2.value = slide2.max;
      }
      updateThumbsAndRanges(getSlideValue(slide1), getSlideValue(slide2));
    }
    var rangeValues = document.querySelectorAll(".rangeValues");
    setPriceRangeValues(rangeValues, true);
  }

  function resetPriceRangeValues(noRangeAndThumbs) {
    var labelLi = document.querySelector(".oa-shop-filter__list li[data-pricerange]");
    if (labelLi) {
      removeFilter('pricerange');
      labelLi.remove();
    }

    priceFilter.resetPriceRangeValues(noRangeAndThumbs)
    if(isFilterListEmpty()) {
      filterContainer.addClass('hidden');
    }
  }

  function countVisibleActiveFilters(list) {
    if (!Array.isArray(list)) return 0;
    var excluded = (nonRemovableActiveFilters || []).slice();
    var ep = activeEntryPointFilter();
    if (ep && excluded.indexOf(ep) === -1) excluded.push(ep);
    if (excluded.length === 0) return list.length;
    return list.filter(function (id) { return excluded.indexOf(id) === -1; }).length;
  }

  function updateOptionsCount() {
    var t = countVisibleActiveFilters(filter);
    if(priceFilter.isActive()) {

      t += 1;
    } else {
      resetPriceRangeValues(true);
    }
    if(window.oaAlgoliaFilter){
      t = countVisibleActiveFilters(oaShopFilter.getFilter());
      if(window.oaAlgolia.priceRangeString != '' && window.oaAlgolia.priceRangeString != undefined){
        t += 1;
      }
    }
    filterCount.text(t > 0 ? '(' + t + ')' : '');
    updateDynamicFilterHeadings();
  }

  function handlePriceSlider(sliders, rangeValues, event){
    priceFilter.handlePriceSlider(this);
    var text = priceFilter.getPriceValuesText(); 
    var labelLi = document.querySelector(".oa-shop-filter__list li[data-pricerange]");
    if(labelLi) {
      if(!priceFilter.isActive()) {
        resetPriceRangeValues(true);
      }
    } else  {
      var li = document.createElement('li');
      li.classList.add('checked');
      li.setAttribute('data-pricerange', true);
      li.setAttribute('data-id', 'pricerange');
      var rangeValues = document.createElement('div');
      rangeValues.classList.add('rangeValues');
      rangeValues.innerHTML = text;
      li.appendChild(rangeValues);
      li.appendChild(createRemoveIcon());
      li.addEventListener('click', function (event) {
        event.preventDefault();
        // removeFilter('pricerange');
        resetPriceRangeValues();
      });
      if (displayActiveFilters && !activeFilterListElements) {
        activeFilterListElements = Array.from(document.querySelectorAll(activeWearFilterListSelector));
      }
      if(priceFilter.isActive()) {
        activeFilterListElements.forEach(function(listEl) {
          listEl.appendChild(li.cloneNode(true));
        });
        if(filterContainer.hasClass('hidden')){
          filterContainer.removeClass('hidden');
        }
      }
    } 
    updateOptionsCount();
  }

  function appendListItemToList(item) {
    if (displayActiveFilters && !activeFilterListElements) {
      activeFilterListElements = Array.from(document.querySelectorAll(activeWearFilterListSelector));
    }
    activeFilterListElements.forEach(function(listEl) {
      listEl.appendChild(item.cloneNode(true));
    });
    if(filterContainer.hasClass('hidden')){
      filterContainer.removeClass('hidden');
    }
  }

  jQuery(document).ready( function($){

    mf = Shopify.money_format.replace(/\{\{ amount[_,a-z]* \}\}/, '{{amount_no_decimals}}');
    sliders = document.querySelectorAll(".range-slider input[type='range']");
    thumbs = document.querySelectorAll(".range-slider .thumb");
    range = document.querySelectorAll(".range-slider .range");
    var rangeValues = document.querySelectorAll(".rangeValues");
    priceRmin = null;
    priceRmax = null;
    priceRangeIndex = null;
    children = null;

    var mobileMainFilter = document.querySelector(".oa-shop-filter__divider-category-mobile");
    
    if(priceFilter && window.oaFilterException){
      priceFilter.init();
    }

    var sliders = priceFilter.getSliders();
    sliders.forEach(function(el){
      el.addEventListener('input', handlePriceSlider.bind(el, sliders, rangeValues));
      el.addEventListener('mouseup', function() {
        animatedScrollTop();
        //Filter the Grid
        document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter: oaShopFilter.getFilter(), filtermin: priceFilter.getPriceRangeValues()[0], filtermax:priceFilter.getPriceRangeValues()[1] } }));
        filterCallback();
      });
      el.addEventListener('touchend', function() {
        animatedScrollTop();
        document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filter: oaShopFilter.getFilter(), filtermin: priceFilter.getPriceRangeValues()[0], filtermax:priceFilter.getPriceRangeValues()[1] } }));
        filterCallback();
      });
    });
    if(window.oaFilterException){
      handlePriceSlider();
    }

    if(mobileMainFilter) {
      mobileMainFilter.querySelectorAll('label').forEach(function(el){
        el.addEventListener('touchstart', function(){
          el.classList.add("touched");
        });
        el.addEventListener('touchend', function(){
          el.classList.remove("touched");
        });
      });
    }

    var $p_filter_desktop_reset = $('.oa-shop-filter__delete-heading');
    var $p_filter_mobile = $('.oa-shop-tabs-mobile');

    //DELETE FILTER STRING ITEMS (MOBILE)
    $('.oa-filter-string').on('click', '.item', function(e){

      var item_id = $(this).attr('data-id');
      var item_index = filter.indexOf(item_id);

      //Srcoll top after Filter Selection
      animatedScrollTop();

      $(e.target).remove();
      filter.splice(item_index, 1);

      $('.'+item_id).removeClass('checked');

      //console.log('.'+item_id);

      filterString = "";
      var l = filter.length;

      filter.forEach(function(item,index){

        appendFilterString('.' + item);

        //add items to filter string 
        var item_string = item.match(/[^_]+$/);
      });

      filterCallback();
    });

    //Handle Reset
    $p_filter_desktop_reset.click(function(e){
      e.preventDefault();

      let nonRemovableFiltersSelector = '';
      if (nonRemovableActiveFilters.length > 0) {
        nonRemovableFiltersSelector += ':not(.non-removable)';
        nonRemovableFiltersSelector += nonRemovableActiveFilters.map(f => `:not([data-id="${f}"])`).join('');
      }
      $('.oa-shop-filter__wrapper [data-id]'+nonRemovableFiltersSelector).removeClass('checked');
      $('.oa-filter-string').text('');
      $('.oa-shop-filter__list li'+nonRemovableFiltersSelector).remove();
      let activeFilterIds = [];
      if (nonRemovableActiveFilters.length > 0) {
        activeFilterIds = Array.from(new Set(Array.from(document.querySelectorAll('.oa-shop-filter__wrapper [data-id].checked')).map(e => e.dataset.id)));
      }
      if (activeFilterIds.length > 0) {
        filterString = activeFilterIds.map(f => `.${f}`).join('');
        setFilter(activeFilterIds);
      } else {
        filterString = '';
        setFilter([]);
      }

      // Hide entry-point filter pill after reset (it stays in filter[] but should not be visible)
      if (nonRemovableActiveFilters.length > 0) {
        nonRemovableActiveFilters.forEach(function(f) {
          $('.oa-shop-filter__list li[data-id="' + f + '"]').remove();
        });
      }

      const $selectedContainer = $('.oa-shop-selected-filters-container');
      if ($('.oa-shop-filter__list li').length) {
        $selectedContainer.removeClass('hidden');
      } else {
        $selectedContainer.addClass('hidden');
      }

      window.__oaSuppressFilterCallback = true;
      resetPriceRangeValues();
      window.oaShopSort.resetSortFilter();
      window.__oaSuppressFilterCallback = false;
      if (window.oaAlgolia) window.oaAlgolia.priceRangeString = '';
      if (activeFilterIds.length === 0) {
        mainFilterAll.addClass('checked');
      }

      animatedScrollTop();
      filterCallback();
    });

    $('.oa-shop-filter__list').on('click', 'li[data-id]', function(e) {
      e.preventDefault();
      var $li = $(this).closest('li');
      var $id = $li.attr('data-id');
      if (nonRemovableActiveFilters.length > 0 && $id && nonRemovableActiveFilters.includes($id)) {
        return;
      }
      var $checkbox = $('.oa-shop-filter .oa-shop-filter__wrapper [data-id="'+$id+'"]');
      $checkbox.removeClass('checked');
      $li.remove();
      $('.oa-shop-filter__list li[data-id="'+$id+'"]').remove();
      removeFilter($id);
      $('.oa-filter-string').text('');
      if (categoryFilters.indexOf($id) != -1) {
        mainFilterAll.addClass('checked');
      }

      if ($('.oa-shop-filter__list li').length === 0) {
        // Preserve non-removable filters (entry-point filters)
        if (nonRemovableActiveFilters.length > 0) {
          var nonRemovableSelector = nonRemovableActiveFilters.map(function(f) { return ':not([data-id="' + f + '"])'; }).join('');
          $('.oa-shop-filter__wrapper [data-id]' + nonRemovableSelector).removeClass('checked');
          filterString = nonRemovableActiveFilters.map(function(f) { return '.' + f; }).join('');
          setFilter(nonRemovableActiveFilters.slice());
        } else {
          $('.oa-shop-filter__wrapper [data-id]').removeClass('checked');
          filterString = '';
          setFilter([]);
          mainFilterAll.addClass('checked');
        }
        $('.oa-filter-string').text('');
        $('.oa-shop-filter__list').empty();
        $('.oa-shop-selected-filters-container').addClass('hidden');
        resetPriceRangeValues();
      }

      filterCallback();
    });
    $p_filter_mobile.find('li a').click( function(e){
      e.preventDefault();

      var id = $(this).attr('data-id');
      if (nonRemovableActiveFilters.length > 0 && id && nonRemovableActiveFilters.includes(id)) {
        return;
      }
 
      $p_filter_mobile.find('li').removeClass('active');
      $(this).parent().addClass('active');
      filterCallback();
    });

    //h1 adjustment on page load
    var filterPart = getFirstFilterStringPart();
    var isSearchPageInit = window.location.pathname === '/search' || window.location.pathname.endsWith('/search');
    if (filterPart) {
      $('.collection-headline span.collection-head-subtext').show();
      if (!isSearchPageInit) {
        let epPath = getEntryPointPath();
        let basePath = collectionPath + collectionHandle + (epPath ? '/' + epPath : '');
        let queryString = filtersToQueryString(filter);
        let newUrl = basePath + queryString;
        if (window.location.pathname + window.location.search !== newUrl) {
          window.history.pushState({ filters: filter.slice() }, '', newUrl);
        }
      }
      var langFilterText = $('.oa-shop-filter__checkbox.'+filterPart).first().text();
      $('.collection-headline span.collection-head-subtext').text(langFilterText);
    }

  });

  // The chip-lighting loop below matches every element carrying a filter's data-id, and the
  // slider chips carry one — so two categories light two chips, and ?category=x lights x
  // alongside the server-rendered "All". Only the sync knows the single-select rule.
  function initUrlFilter(mainFilter) {
    applyUrlFilter(mainFilter);
    syncCategorySliderToSidebar();
  }

  function applyUrlFilter(mainFilter) {
    // filterSettingsFashion loads after this file, so the path filter could not be classified
    // when it was read. A colour/size path is an ordinary removable filter, not an entry point.
    if (entryPointFilter && !isEntryPointEligible(entryPointFilter)) entryPointFilter = '';

    if (collectionHandle != 'shop' && window.oaFilterException) {
    }

    if (!urlState || (Array.isArray(urlState) && urlState.length === 0)) {
      return;
    }

    const states = urlState.split('+');

    seedNonRemovableFromStates(states);

    const matchesCollection = states.length === 1 && states[0] === collectionHandle;

    if (!matchesCollection) {
      if (states.length === 1 && states[0] === 'all') {
        return;
      }

      const uniqueStates = [...new Set(states.filter(s => s && s !== 'all'))];
      if (uniqueStates.length === 0) return;

      setFilter(uniqueStates);
      filterString = uniqueStates.map(s => '.' + s).join('');
      //window.oaShopFilter.updateShopBannerTitle();

      uniqueStates.forEach(state => {
        $('.oa-shop-filter [data-id="' + state + '"]').addClass('checked');
        scrollElementIntoViewIfNeeded(state, mainFilter);
      });
    } else {
      mainFilterAll.addClass('checked');
    }

    const parts = oaShopFilter.getUrlState().split('+');
    if (parts.length > 0) {
      var visibleCount = countVisibleActiveFilters(parts);
      filterCount.text(visibleCount > 0 ? '(' + visibleCount + ')' : '');
    }
  }

    function countFilteredItems(list, filter) {
    if(list) {
      if(filter){
        list.filter(function (f) {
          return f !== filter;
        });
      }
    }
    var filters = window.oaShopFilter.getFilter().filter(function (f) { return list.indexOf(f) === -1 && f !== filter; });
  }

  function setCategoryCountResultText (list) {
    list.forEach(function(f) {
      var rText = countFilteredItems(list, f); 
      var label = $('.filter-result-'+f).closest('label');
      if(!label.hasClass('checked')) {
        if(rText == 0){
          if(!label.hasClass('hidden')) {
            label.addClass('hidden');
          }
        } else {
          if(label.hasClass('hidden')) {
            label.removeClass('hidden');
          }
        }
      }
      console.log(f);
      // $('.filter-result-'+f).text('('+ rText +')');
    });
  }

  function countCategories(list){
    var filteredItems = countFilteredItems(list);
    
    $('.filter-result-all').text('('+filteredItems+')');
    setCategoryCountResultText(list);
  }

  function collision() {
    if (!collisionPartnerMain.length || !collisionPartnerSub.length) { return false; }
    var y1 = collisionPartnerMain.offset().top;
    var y2 = collisionPartnerSub.offset().top;
    var h2 = collisionPartnerSub.outerHeight(true) + 1;
    var b2 = y2 + h2;
    if (y1 >= (b2-h2)) { return false; }
    return true;
  }

  function initMainFilterClass() {
    $(window).scroll(function() {
      //var $div1 = $("#testId");
      //var $div2 = $(".oa-shop-filter--desktop");
      if(collision()) {
        mainFilterClass.removeClass("mainFilterClass--hidden");
      } else {
        if(!mainFilterClass.hasClass("mainFilterClass--hidden")) { 
          mainFilterClass.addClass("mainFilterClass--hidden");
        }
      }

    });
  }

  function scrollElementIntoViewIfNeeded(id, element) {
    if(categoryFilters.indexOf(id) != -1) {
      if (element) {
        //element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      //$('.oa-shop-filter__sub__inner-flex-mobile label[data-id="'+id+'"]').get(0).scrollIntoViewIfNeeded();
    } else {
      if (element) {
        //element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }
  
  /*function scrollElementIntoViewIfNeeded(id) {
    if(categoryFilters.indexOf(id) != -1) {
      $('.oa-shop-filter__sub__inner-flex-mobile label[data-id="'+id+'"]').get(0).scrollIntoViewIfNeeded();
    }
  }*/

  // Handle browser back/forward navigation
  window.addEventListener('popstate', function () {
    var isSearchPage = window.location.pathname === '/search' || window.location.pathname.endsWith('/search');
    if (isSearchPage) return;

    // Re-read entry point from path and other filters from query params
    var popPathFilter = window.location.pathname.split('/').filter(function (p) { return p.length > 0; }).pop();
    if (popPathFilter === collectionHandle) popPathFilter = '';
    entryPointFilter = (popPathFilter && isEntryPointEligible(popPathFilter)) ? popPathFilter : '';

    var newFilters = queryStringToFilters();
    if (popPathFilter) newFilters.unshift(popPathFilter);

    // Reset UI. Every chip is rendered twice — a version-b div and a version-a label — so this
    // clears half the slider; syncCategorySliderToSidebar() below resets and re-applies all of it.
    $('.oa-shop-filter .oa-shop-filter__wrapper label').removeClass('checked');
    $('.oa-shop-filter__list li').remove();
    if (window.oaAlgolia) {
      window.oaAlgolia.activeCategoryFilters = '';
      // Price is never encoded in the URL, so the restored state has none.
      window.oaAlgolia.priceRangeString = '';
    }
    // Full reset under the "delete all" guard: the partial form re-reads the untouched thumbs
    // and restores what it cleared, and the dispatch would carry the pre-navigation filter.
    window.__oaSuppressFilterCallback = true;
    resetPriceRangeValues();
    window.__oaSuppressFilterCallback = false;
    seedNonRemovableFromStates(newFilters);

    // Re-apply filters
    filter = [];
    filterString = '';
    urlState = '';
    if (newFilters.length > 0) {
      mainFilterAll.removeClass('checked');
      setFilter(newFilters);
      newFilters.forEach(function(state) {
        $('.oa-shop-filter [data-id="' + state + '"]').addClass('checked');
      });
    } else {
      mainFilterAll.addClass('checked');
    }

    // The loop above checks every element carrying the filter's data-id, and the slider chips
    // carry one too — so two categories would light two chips. Let the shared sync decide.
    syncCategorySliderToSidebar();

    // Both click paths sweep these after a category change; without it, dynamically injected
    // children (accessory sizes, leg length) outlive the category the restored URL dropped.
    cleanupInvalidDynamicChildren();
    // Derived from filter, not newFilters — the sweep above drops orphaned dynamic children.
    filterString = filter.map(function (s) { return '.' + s; }).join('');
    urlState = filter.join('+');
    if (typeof window.updateDynamicFilterVisibility === 'function') {
      window.updateDynamicFilterVisibility(filter.slice());
    }

    document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: { filter: filter } }));
    // filterCallback() never runs here, so countItems() does not either and the badge would keep
    // the pre-navigation count. Suppressed: its price branch dispatches a redundant second event.
    window.__oaSuppressFilterCallback = true;
    updateOptionsCount();
    window.__oaSuppressFilterCallback = false;
  });

  return {
    animatedScrollTop: animatedScrollTop,
    updateShopBannerTitle: updateShopBannerTitle,
    collectionHandle: collectionHandle,
    getFilter: function () { return filter; },
    setFilter: setFilter,
    appendFilter: appendFilter,
    getFilterString: function () { return filterString; },
    setFilterString: function (fs) { filterString = fs; },
    appendFilterString: appendFilterString,
    getUrlState: function () { return urlState; },
    setUrlState: function (us) { urlState = us; },
    handleCheckboxClick: handleCheckboxClick,
    handleCategorySliderClick: handleCategorySliderClick,
    updateDynamicFilterHeadings: updateDynamicFilterHeadings,
    filterCallback: filterCallback,
    initUrlFilter: initUrlFilter,
    enableDisplayActiveFilters: function () { displayActiveFilters = true; },
    getNonRemovableActiveFilters: function () { return nonRemovableActiveFilters.slice(); },
    setNonRemovableActiveFilters: function (filters) {
      nonRemovableActiveFilters = filters;
    },
    createRemoveIcon: createRemoveIcon,
    getFilteredItemCount: getFilteredItemCount,
    initCategoryFilter: initCategoryFilter,
    handlePriceSlider: handlePriceSlider,
    updateOptionsCount: updateOptionsCount,
    appendListItemToList: appendListItemToList,
    isFilterListEmpty: isFilterListEmpty,
    isCategoryInFilter: isCategoryInFilter,
    countCategories: countCategories,
    initMainFilterClass: initMainFilterClass,
    getFilterGroup: getFilterGroup,
    getCategoryChipId: getCategoryChipId,
    groupToParamKey: groupToParamKey,
    paramKeyToGroup: paramKeyToGroup,
    filtersToQueryString: filtersToQueryString,
    queryStringToFilters: queryStringToFilters,
    getEntryPointFilter: activeEntryPointFilter,
    setEntryPointFilter: function (ep) { entryPointFilter = ep; }
  };
})();

window.oaShopSort = (function () {

  var labels,
      activeClass = 'checked';

  function uncheckLabel(label) {
    $(label).removeClass(activeClass);
  }

  function uncheckLabels() {
    if (!labels) {
      labels = $('.oa-sort-container label, .desktop-sort-by-dropdown label, .desktop-sort-by-dropdown a');
    }
    labels.each(function () {
      uncheckLabel(this);
    });
  }

  function checkPopularSort() {
    labels = $('.oa-sort-container label, .desktop-sort-by-dropdown label, .desktop-sort-by-dropdown a');
    labels.each(function () {
      var $label = $(this);
      var sortOption = $label.attr('data-sort-option');
      if (sortOption) {
        try {
          var parsed = typeof sortOption === 'string' ? JSON.parse(sortOption) : sortOption;
          if (
            parsed &&
            parsed.sortBy === 'order' &&
            parsed.sortAscending === true
          ) {
            checkLabel($label);
          }
        } catch (e) {
          // ignore parse errors
        }
      }
    });

  }

  function updateGrid(options) {

    if (window.__oaSuppressFilterCallback) return;

    if(!window.oaFilterException){
      if(options.sortBy == 'order'){
        options = JSON.stringify(options);
      }
      document.dispatchEvent(new CustomEvent('oa:filterCallback', { detail: {filterSort: JSON.parse(options) } }));
      return;
    }

    if (typeof options === 'string') {
      options = JSON.parse(options);
    }
  }

  function checkLabel(label) {
    label.addClass(activeClass);
    updateGrid(label.attr('data-sort-option'));
  }

  function createListElement(self) {
    var li = document.createElement('li');
    li.setAttribute('data-id', 'selected-sort');
    li.setAttribute('data-sort-by', true);
    li.innerHTML = self.text();	
    li.appendChild(window.oaShopFilter.createRemoveIcon());
    window.oaShopFilter.appendListItemToList(li);	
  }	

  function resetSortFilter() {
    uncheckLabels();
    if (window.oaShopFilter.isFilterListEmpty() && window.oaShopFilter.isPriceFilterSet != undefined && !window.oaShopFilter.isPriceFilterSet()) {
      $('.oa-shop-selected-filters-container').addClass('hidden');
      if (window.oaShopFilter.isCategoryInFilter(window.oaShopFilter.getFilter()[0])) {
        $('.oa-shop-filter [data-all="all"]').addClass('checked');
      }
    }

    checkPopularSort();
  }

  function initCheckboxes() {
    $('.oa-sort-container label[data-sort-option]').on('click', function(event) {
      event.preventDefault();

      var self = $(this);
      if (self.hasClass('checked')) {
        return;
      }
      var elPopular = self.parent().children().first();
      var text = self.text();
      var labelLi = document.querySelectorAll(".oa-shop-filter__list li[data-sort-by]");
      var filterContainer = $('.oa-shop-selected-filters-container');

      labelLi.forEach(function(item) {
        item.remove();
      });

      const isDefaultSort = text === elPopular.text();

      if (!isDefaultSort) {
        createListElement(self);
      } else {
        var isFilterEmpty = window.oaShopFilter.isFilterListEmpty();
        var isPriceFilterSet = window.oaShopFilter.isPriceFilterSet && window.oaShopFilter.isPriceFilterSet();

        if (isFilterEmpty && !isPriceFilterSet) {
          filterContainer.addClass('hidden');
  
          var currentFilter = window.oaShopFilter.getFilter();
          if (currentFilter && currentFilter[0] && window.oaShopFilter.isCategoryInFilter(currentFilter[0])) {
            $('.oa-shop-filter [data-all="all"]').addClass('checked');
          }
        }
      }

      uncheckLabels();

      window.oaShopFilter.updateOptionsCount();

      var labelToCheck = isDefaultSort ? elPopular : self;
      checkLabel(labelToCheck);
    });
  }

  function initDropdown() {
    $('.desktop-sort-by-dropdown [data-sort-option]').on('click', function(event) {
      event.preventDefault();
      uncheckLabels();
      checkLabel($(this));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCheckboxes();
    initDropdown();
  }, false);

  return {
    resetSortFilter: resetSortFilter
  };
})();

window.oaShopGridToggle = (function () {
  var domain = window.location.hostname.replace(/^[^.]+/g, '');

  var selectorDefault = '.grid-toggle-default',
      selectorFull = '.grid-toggle-full',
      classActive = 'grid-box-button--active',
      classGridFull = 'oa-shop-grid--full';

  var elDefault,
      elFull,
      elShopGrid;

  function onToggle(type, event) {
    if (event) {
      event.preventDefault();
    }
    if (!elShopGrid) {
      elShopGrid = document.querySelector('.oa-shop-grid');
    }
    if (!elShopGrid) return;

    elDefault.forEach(function(btn) {
      btn.classList[type === 'default' ? 'add' : 'remove'](classActive);
    });
    elFull.forEach(function(btn) {
      btn.classList[type === 'full' ? 'add' : 'remove'](classActive);
    });

    if (type === 'default') {
      elShopGrid.classList.remove(classGridFull);
    } else if (type === 'full') {
      elShopGrid.classList.add(classGridFull);
    }

    Cookies.set('oa_grid_layout', type, {expires: 30, path: '/', domain: domain});
  }

  document.addEventListener('DOMContentLoaded', function () {
    elDefault = document.querySelectorAll(selectorDefault);
    elFull = document.querySelectorAll(selectorFull);

    if (!elDefault || !elFull) { return; }

    elDefault.forEach(function(item) {
      item.addEventListener('click', onToggle.bind(item, 'default'));
    });
    elFull.forEach(function(item) {
      item.addEventListener('click', onToggle.bind(item, 'full'));
    });

    var type = Cookies.get('oa_grid_layout', {domain: domain});
    if (type && type !== 'default') {
      //onToggle(type, null);
    }
  }, false);

  return {

  };

})();

function applyFilterSelection() {
  window.oaHeaderSidenav.hide();
  $('.oa-header__sidenav__main').css('display', 'block');
  $('html').removeClass('oa-filtermobile--opened oa-sortmobile--opened');
  $('.oa-header__sidenav').removeClass('oa-header__sidenav--open');
  $('#oa-filter-sidebar').removeClass('visibleside');
  $('#oa-sort-sidebar').removeClass('visibleside');
}

document.addEventListener('DOMContentLoaded', function() {
  window.oaStickySidebar.setup();

  $('#side-filter-toggle').click(function() {
    window.oaHeaderSidenav.show();
    $('html').toggleClass('oa-filtermobile--opened');
    $('.oa-header__sidenav__main').css('display', 'none');
    $('.oa-header__sidenav').addClass('oa-header__sidenav--open');

  });

  $('.side-sort-toggle').click(function() {
    window.oaHeaderSidenav.show();
    $('html').toggleClass('oa-sortmobile--opened');

    $('.oa-header__sidenav__main').css('display', 'none');
    $('.oa-header__sidenav').addClass('oa-header__sidenav--open');
  });

  $('.oa-bckdrp19').click(function() {
    $('.oa-header__sidenav__main').css('display', 'block');
    $('html').removeClass('oa-filtermobile--opened');
    $('html').removeClass('oa-sortmobile--opened');
    $('.oa-header__sidenav').removeClass('oa-header__sidenav--open');
    $('#oa-filter-sidebar').removeClass('visibleside');
  });
});

(function () {
  window.oa_open_filter_mob = function () {
    window.oaHeaderSidenav.show();
    $('html').toggleClass('oa-filtermobile--opened');
    $('.oa-header__sidenav__main').css('display', 'none');
    $('.oa-header__sidenav').addClass('oa-header__sidenav--open');

    $('#oa-filter-sidebar').addClass('visibleside');
    $('#headertoggle').removeClass('oa-hdr19-top__toggle--toggled');
    // if (! $('#oa-shop-filter__fashion-size-in').hasClass('active')) {
    //   $('#oa-shop-filter__fashion-size-in').trigger('click')
    // }
    // if (! $('#oa-shop-filter__fashion-activity-in').hasClass('active')) {
      // $('#oa-shop-filter__fashion-activity-in').trigger('click')
    // }
  }

  window.oa_open_sort_mob = function () {
    console.log("oa_open_sort_mob");
    $('.oa-filter-sidebar-wrapper').show();
    // $('#oa-filter-sidebar').show();
    setTimeout(function(){
      $('#headertoggle').removeClass('oa-hdr19-top__toggle--toggled');
    }, 50);
  }

  var oaShopFilterAnimating = false;
  window.clickFilter = function (selected, el) {
    if (oaShopFilterAnimating) return;
    oaShopFilterAnimating = true;
    var isDesktop = $(el).parents('.oa-shop-filter--desktop').length == 1;
    var h = $('.oa-shop-collection-box .oa-shop-filter .oa-shop-filter__sub-heading');
    var filterSelector = (isDesktop ? '.oa-shop-filter--desktop ' : '.oa-header__sidenav ') + selected;
    var $filter = $(filterSelector);

    if (isVersionA(el)) {
      oaShopFilterAnimating = false;
      $filter.toggle();
      $(el).toggleClass('active');
      $(el).parent().toggleClass('active');

      if (isDesktop) {
        h.each(function() {
          if(el == this) {return;}
          if($(this).hasClass('active')){
            $(this).next().toggle();
            $(this).toggleClass('active'); 
            $(this).parent().toggleClass('active'); 
          }
        });
      }
    } else {
      $filter.slideToggle(200, function() {
        if (!$filter.is(':visible')) {
          $filter.css('height', '');
        }
        oaShopFilterAnimating = false;
      });

      $(el).toggleClass('active');
      $(el).parent().toggleClass('active');
    }

  };
  
})();

// TODO: Achtung, wenn man mit geöffneter Device Toolbar testet, dann wird isMobile immer true
$( document ).ready(function() {
  if(isMobile()) {
    // $('.oa-shop-filter__sub-heading').addClass('active');
    // $('.oa-shop-filter__sub-heading').next().css('display', 'block');
  } 
});

document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('#oa-shop-filter__main');
  if (!el) { return; }
  const elBtn = el.querySelector('.sort-filter-box .btn-trigger-filter-mobile');
  if (!elBtn) { return; }
  function handleScroll () {
    if (window.outerWidth >= 1370) {
      return;
    }
    elBtn.classList.toggle('hidden', window.scrollY <= el.getBoundingClientRect().bottom+206);
  }
  window.addEventListener('scroll', throttle(100, handleScroll), { passive: true });
  handleScroll();
});
